import { useState, useEffect } from "react";
import { Frame, Loading, Header, ValidaUid } from "../components";
import { db } from "../config/firebase";
import { doc, getDoc } from "firebase/firestore";
import { ValidaLinha } from "../components/Validacao";
import { useNavigate } from "react-router-dom";
import QRCode from "react-qr-code";
import Logo from "../assets/logo2.png";
import moment from "moment";

const Home = () => {
  const [loading, setLoading] = useState(true);
  const [dados, setDados] = useState({});

  const navigate = useNavigate();

  const buscaDados = async () => {
    const uid = await ValidaUid();

    if (uid) {
      const qry = await getDoc(doc(db, "desconto2026", uid));

      setDados(qry.data());
      setLoading(false);
    } else {
      navigate("../home");
    }
  };

  useEffect(() => {
    buscaDados();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Header nome={dados?.nome} foto={dados?.urlFoto} />

      {loading && <Loading />}

      {!loading && !dados?.status && <Novo />}
      {!loading && dados?.status === "e" && <Incorreto dados={dados} />}
      {!loading && dados?.status === "p" && <Pendente />}
      {!loading && dados?.status === "i" && <Inativo />}
      {!loading && dados?.status === "c" && <Cancelado />}
      {!loading && dados?.status === "a" && <Aprovado dados={dados} />}
    </>
  );
};

export default Home;

const Aprovado = (props) => {
  return (
    <Frame
      body={
        <div className="container-fluid">
          <div className="col-sm-6 mx-auto">
            <img className="mt-2" src={Logo} width={250} alt="logo" />
            <h4 className="mt-2 py-1 bg-danger bg-gradient text-white rounded-1">
              DESCONTO 10%
            </h4>

            <div className="mt-2">
              <QRCode size={150} value={"378|" + props.dados.uid} />
            </div>

            <img
              src={props.dados.urlFoto}
              alt="Usuário"
              width="150"
              height="150"
              className="d-inline rounded-circle mt-2"
            />

            <div className="mt-2">
              <h4 className="mt-2 py-1 bg-danger bg-gradient text-white rounded-1">
                {props.dados.nome}
              </h4>
            </div>
            <div className="mt-2 mx-auto fs-5">
              <div className="mt-1">
                <span className="fw-bold azul-logo">Carteira: </span>
                {props.dados.contrato}
              </div>
              <div className="mt-1">
                <span className="fw-bold azul-logo">CPF: </span>
                {props.dados.cpf}
              </div>
              <div className="mt-1">
                <span className="fw-bold azul-logo">RG: </span>
                {props.dados.rg}
              </div>
              <div className="mt-1">
                <span className="fw-bold azul-logo">Validade: </span>
                {moment(props.dados.validade || "2026-12-31").format(
                  "DD/MM/YYYY",
                )}
              </div>
              {props.dados.linha1 && (
                <div className="fw-bold azul-logo mt-1">
                  {ValidaLinha(props.dados.linha1)}
                </div>
              )}
              {props.dados.linha2 && (
                <div className="fw-bold azul-logo mt-1">
                  {ValidaLinha(props.dados.linha2)}
                </div>
              )}
              {props.dados.linha3 && (
                <div className="fw-bold azul-logo mt-1">
                  {ValidaLinha(props.dados.linha3)}
                </div>
              )}
            </div>
          </div>
        </div>
      }
    />
  );
};

const Novo = () => {
  return (
    <Frame
      body={
        <div className="px-4 text-start">
          <div className="my-4">
            <h5>Como funciona?</h5>
            <div className="mt-4">
              Estudantes e professores que têm direito ao benefício recebem uma
              carteira digital com os seguintes descontos:
            </div>
            <ul className="mt-4">
              <li>
                <b>10% de desconto</b> na compra de passagens na rodoviária ou
                no embarque;
              </li>
              <li>
                <b>20% de desconto</b> na compra antecipada de vale-transporte,
                sempre em <b>múltiplos de seis</b>.
              </li>
            </ul>
          </div>

          <hr />

          <div className="my-4">
            <h5>Quem tem direito ao benefício?</h5>

            <h6 className="mt-4">Estudantes:</h6>
            <ul>
              <li>
                Alunos do ensino fundamental, médio ou superior que residem em
                município diferente daquele onde está localizada a instituição
                de ensino e que utilizam transporte para fins educacionais.
              </li>
            </ul>

            <h6 className="mt-4">Professores:</h6>

            <ul>
              <li>
                Professores do ensino fundamental e médio que residem em
                município diferente daquele onde atuam e que utilizam transporte
                para fins profissionais.
              </li>
            </ul>
          </div>

          <hr />

          <div className="my-4">
            <h5>Como solicitar?</h5>
            <div className="mt-4">
              Se você se enquadra em uma dessas categorias, clique no botão
              abaixo e preencha o formulário de solicitação.
            </div>
          </div>

          <div className="my-4 d-grid">
            <a className="btn btn-primary" href="./form1">
              Cadastrar
            </a>
          </div>
        </div>
      }
      title="Desconto Estudantil"
    />
  );
};

const Pendente = () => {
  return (
    <Frame
      body={
        <div className="justify p-3">
          <p>
            Sua solicitação do benefício foi recebida. Agora, vamos validar as
            informações enviadas e, caso encontremos alguma inconformidade,
            iremos informá-lo aqui no portal.
          </p>

          <div className="alert alert-warning text-center mt-4" role="alert">
            Por favor, verifique o portal novamente a partir do próximo dia
            útil.
          </div>
        </div>
      }
      title="Cadastro em Análise"
    />
  );
};

const Incorreto = (props) => {
  return (
    <Frame
      body={
        <div className="p-3 text-start">
          <p>
            Encontramos algumas inconformidades durante a validação da sua
            solicitação do benefício.
          </p>

          <p>
            Abaixo, seguem as instruções sobre o que deve ser ajustado. Por
            gentileza, ajuste os dados e reenvie-os.
          </p>
          <div className="alert alert-danger mt-4 text-center" role="alert">
            {props.dados.observacao}
          </div>

          <div className="mt-4 text-end">
            <a className="btn btn-primary" href="./form1">
              Ajustar
            </a>
          </div>
        </div>
      }
      title="Verifique seus dados"
    />
  );
};

const Inativo = () => {
  return (
    <Frame
      body={
        <div>
          <p>Seu cadastro encontra-se inativo.</p>
          <p>Para reativá-lo, entre em contato conosco.</p>
          <p>Whatsapp: (53) 99125-5743</p>
        </div>
      }
      title="Cadastro Inativo"
    />
  );
};

const Cancelado = () => {
  return (
    <Frame
      body={
        <div>
          <p>Seu cadastro conosco encontra-se cancelado.</p>
          <p>Para reativá-lo, entre em contato conosco.</p>
          <p>Whatsapp: (53) 99125-5743</p>
        </div>
      }
      title="Cadastro Cancelado"
    />
  );
};
